import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { env } from "../infrastructure/environment";

// Initialize Datadog RUM
datadogRum.init({
    applicationId: env.DATADOG_APPLICATION_ID,
    clientToken: env.DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: env.DATADOG_SERVICE,
    env: env.DATADOG_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackLongTasks: true,
    trackResources: true,
    // Disable router plugin since we're using react-router v5 (not v6/v7)
    plugins: [reactPlugin({ router: false })],
});

export default datadogRum;